import type { ReactNode } from 'react';

export type ChipTone = 'plain' | 'teal' | 'gold' | 'success' | 'warning' | 'error';

export default function Chip({
  children,
  tone = 'plain',
  dot = false,
  className = '',
}: {
  children: ReactNode;
  tone?: ChipTone;
  dot?: boolean;
  className?: string;
}) {
  return (
    <span className={`chip ${tone === 'plain' ? '' : `chip-${tone}`} ${className}`.trim()}>
      {dot ? <span className="chip-dot" aria-hidden="true" /> : null}
      {children}
    </span>
  );
}
